type UrlConfig = {
  apiHost: string;
  exitHost: string;
  homepageHost: string;
  contentHost: string;
  previewHost: string;
};

export const urlConfig: UrlConfig = {
  apiHost: getApiHost(),
  exitHost: import.meta.env.VITE_EXIT_HOST ?? window.location.origin,
  homepageHost: import.meta.env.VITE_HOMEPAGE_HOST ?? window.location.origin,
  contentHost: "https://content.rome2rio.com",
  previewHost: "https://content-preview.rome2rio.com",
};

function getApiHost() {
  if (import.meta.env.VITE_DEBUG_HOST_ENABLED !== "true") {
    return import.meta.env.VITE_API_HOST;
  }

  const debugHost = new URLSearchParams(window.location.search).get(
    "debugHost",
  );
  return debugHost ?? import.meta.env.VITE_API_HOST;
}
